import React, { FC } from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { isUndefined } from "lodash";

import s from "./styles.less";

interface Props {
  name: string;
  onClick: (e) => void;
  clickable: boolean;
}

const Status: FC<Props> = ({ name, onClick, clickable = false }) => {
  const { t } = useTranslation();

  const list = {
    active: { color: "#40A83D", title: t(`statuses.active`) },
    draft: { color: "#FF9633", title: t(`statuses.draft`) },
    reject: { color: "#FF333A", title: t(`statuses.reject`) },
    failed: { color: "#FF333A", title: t(`statuses.reject`) },
    verified: { color: "#40A83D", title: t(`statuses.verified`) },
    notVerified: { color: "#FF333A", title: t(`statuses.notVerified`) },
  };

  const current = isUndefined(list[name])
    ? { color: "#222", title: "Не определено" }
    : list[name];

  return (
    <div
      className={clsx(s.container, {
        [s.clickable]: clickable,
      })}
      onClick={clickable ? onClick : null}
    >
      <span className={s.circle}>
        <span style={{ backgroundColor: current.color }} />
      </span>
      {current.title}
    </div>
  );
};

export default Status;
